import React, { useState } from "react";
import axios from "axios";
import { useAppContext } from "../../contexts/AppContext";
import RichTextForm from "../Forms/RichTextForm";
import ButtonForm from "../Forms/ButtonForm";

function TranslationForm({ onCancel, onSuccess }) {
  const [engTranslation, setEngTranslation] = useState("");
  const [tigTranslation, setTigTranslation] = useState("");
  const [amhTranslation, setAmhTranslation] = useState("");
  const { backendUrl } = useAppContext();
  const translationRoute = "/translations";

  const stripOuterHtml = (html) => {
    if (!html) return html;
    return html.replace(/^<[^>]+>(.*)<[^>]+>$/s, "$1").trim();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!engTranslation || !tigTranslation || !amhTranslation) {
      alert("All fields are required!");
      return;
    }

    try {
      const response = await axios.post(`${backendUrl}${translationRoute}`, {
        engTranslation: stripOuterHtml(engTranslation),
        tigTranslation: stripOuterHtml(tigTranslation),
        amhTranslation: stripOuterHtml(amhTranslation),
      });

      alert(response.data.message);
      setEngTranslation("");
      setTigTranslation("");
      setAmhTranslation("");
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Error adding translation:", error);
      alert("An error occurred while submitting the translation.");
    }
  };

  return (
    <div className="bg-white rounded-3 shadow-sm p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="fw-bold m-0">Add New Translation</h5>
        {onCancel && (
          <ButtonForm onclick={onCancel} buttonText="Cancel" color="btn-secondary" />
        )}
      </div>

      <form onSubmit={handleSubmit} className="row g-3">
        <div className="col-12">
          <RichTextForm
            labelName={"English sentence / word"}
            value={engTranslation}
            onchange={setEngTranslation}
          />
        </div>

        <div className="col-12 mt-3">
          <RichTextForm
            labelName={"ትርጉም ብትግርኛ (Tigrinya)"}
            value={tigTranslation}
            onchange={setTigTranslation}
          />
        </div>

        <div className="col-12 mt-3">
          <RichTextForm
            labelName={"ትርጉም በ ኣማርኛ (Amharic)"}
            value={amhTranslation}
            onchange={setAmhTranslation}
          />
        </div>

        <div className="col-12 mt-4">
          <button type="submit" className="btn btn-primary w-100 py-2 fw-bold" style={{ backgroundColor: "var(--primary-color)", border: "none" }}>
            Submit Translation
          </button>
        </div>
      </form>
    </div>
  );
}

export default TranslationForm;
